import { useState } from "react";
import CustomDialog from "../../../components/Dialog/DiaCompMedium";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
//import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Grid from '@mui/material/Grid';
import MetabolicCard from "./ShopCardsMarker/MetabolicCard";
import LiverPancreasCard from "./ShopCardsMarker/LiverPancreasCard";
import KidneyCard from "./ShopCardsMarker/KidneyCard";
import VitaminsCard from "./ShopCardsMarker/VitaminsCard";
import ImmunityCard from "./ShopCardsMarker/ImmunityCard";
import HormoneCard from "./ShopCardsMarker/HormoneCard";
//import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import { Book, BookText } from "lucide-react";


export default function DiaBaseTests({infotitle, infotext}) {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title="60+ Bloodmarkers" placement="right">
            <IconButton onClick={handleOpen} aria-label="Reschedule" sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                <BookText size={20} sx={{'&:hover': { transform: 'scale(1.4)'}, }}/>
            </IconButton>   
        </Tooltip>
   
    <CustomDialog open={open} onClose={handleClose}

          title="What bloodmarkers are included in 1 year membership tests?"
         
          content = {
          
           <Grid container>

              <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>  


     {/* Cards */}
    <Grid container spacing={{xs:1, md:2 }}>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><MetabolicCard /></Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><ImmunityCard /> </Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><LiverPancreasCard /></Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><KidneyCard /> </Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><VitaminsCard /> </Grid>
       <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><HormoneCard /> </Grid>
    </Grid>



              
              </Grid>
            
            </Grid>
            }

        />
        
</>
)}